<div id="dark" class="trades-news">
  <h2 class="heading">{{"detailed-quota"|translate}}</h2>
  <div class="row m-1">
    <table class="table row m-0 p-0 custom-depth">
      <tbody>
        <tr class="width-100">
          <td [colSpan]="3">
            <strong>{{companyQuota?.ENG_NAME}}</strong>
          </td>
          <td class="fit">
            {{companyQuota?.SYMBOL_CODE}}
          </td>
          <td class="fit">
            {{companyQuota?.Reuters}}
          </td>
          <td class="fit">
            <span [ngClass]="companyQuota?.SYMBOL_STATE == 'A'? 'dot-green' : 'dot-red'"></span>
          </td>
        </tr>
        <tr style="width: 35% !important;">
          <td class="fit">{{'Last Price'|translate}}</td>
          <td colspan="3" class="fit">
            {{companyQuota?.LAST_TRADE_PRICE| number: "1.0":"en-US"}}
          </td>
          <td class="fit">{{'Prev. Close'|translate}}</td>
          <td class="fit">
            {{companyQuota?.PREVIOUS_CLOSE| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'High'|translate}}</td>
          <td colspan="3" class="fit">
            {{companyQuota?.HIGH_PRICE| number: "1.0":"en-US"}}
          </td>
          <td class="fit">{{'Low'|translate}}</td>
          <td class="fit">
            {{companyQuota?.LOW_PRICE| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Open'|translate}}</td>
          <td colspan="3" class="fit">
            {{companyQuota?.OPEN_PRICE| number: "1.0":"en-US"}}
          </td>
          <td class="fit">{{'Close'|translate}}</td>
          <td class="fit">
            {{companyQuota?.CLOSE_PRICE| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Change'|translate}}</td>
          <td colspan="3" class="fit" [ngClass]="companyQuota?.AVG_CHANGE>0? 'green' : 'red'">
            {{companyQuota?.AVG_CHANGE}}
          </td>
          <td class="fit">{{'Change'|translate}}%</td>
          <td class="fit" [ngClass]="companyQuota?.AVG_CHANGE>0? 'green' : 'red'">
            {{companyQuota?.AVG_CHANGE_PRC}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Volume'|translate}}</td>
          <td colspan="3" class="fit">
            {{companyQuota?.TOTAL_VOLUME}}
          </td>
          <td class="fit">TurnOver{{'TurnOver'|translate}}</td>
          <td class="fit">
            {{companyQuota?.TOTAL_VALUE| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Highest Bid'|translate}}</td>
          <td colspan="3" class="fit">
            {{companyQuota?.BID_PRICE| number: "1.0":"en-US"}}
          </td>
          <td class="fit">{{'Lowest Ask'|translate}}</td>
          <td class="fit">
            {{companyQuota?.ASK_PRICE| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Bids'|translate}}</td>
          <td class="fit" colspan="3">
            {{companyQuota?.TOTAL_BIDS| number: "1.0":"en-US"}}
          </td>
          <td class="fit">{{'Asks'|translate}}</td>
          <td class="fit">
            {{companyQuota?.TOTAL_ASKS| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Low 52 Week'|translate}}</td>
          <td class="fit" colspan="3">
            {{companyQuota?.LOW_52_WEEk| number: "1.0":"en-US"}}
          </td>
          <td class="fit">{{'High 52 Week'|translate}}</td>
          <td class="fit">
            {{companyQuota?.HIGH_52_WEEK| number: "1.0":"en-US"}}
          </td>
        </tr>
        <tr>
          <td class="fit">{{'Market'|translate}}</td>
          <td class="fit" colspan="3">
            {{companyQuota?.MARKET_ID}}
          </td>
          <td class="fit">{{'Currency'|translate}}</td>
          <td class="fit">
            {{companyQuota?.CURRENCY| number: "1.0":"en-US"}}
          </td>
        </tr>

      </tbody>
    </table>
  </div>
  <div class="row">
    <div class="col-6 p-0">
      <app-quota-bids-asks [symbolCode]="this.symbolCode"></app-quota-bids-asks>
    </div>
    <div class="col-6 p-0">
      <app-quota-trade [symbolCode]="this.symbolCode"></app-quota-trade>
    </div>
  </div>
</div>
